module.exports = __webpack_public_path__ + "static/media/voucher-icon.6a5c27c4.svg";